/**
 * STRUTT 商品详情页 JavaScript
 * 处理数量选择器、直接结账、折叠面板等功能
 */

document.addEventListener('DOMContentLoaded', function() {
  const normalizeAccessoryText = (value) => {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[’]/g, "'")
      .replace(/[¹]/g, '1')
      .replace(/[–—]/g, '-');
  };

  const decodeHtmlEntities = (value) => {
    const input = String(value || '');
    if (!input || input.indexOf('&') === -1) return input;

    const textarea = document.createElement('textarea');
    textarea.innerHTML = input;
    return textarea.value;
  };

  const escapeHtml = (value) => {
    return decodeHtmlEntities(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const formatMultilineText = (value, options) => {
    return escapeHtml(String(value || '')).replace(/\n/g, '<br>');
  };

  const renderParagraphs = (items) => {
    if (!Array.isArray(items) || !items.length) return '';
    return items.map((item) => `<p>${formatMultilineText(item)}</p>`).join('');
  };

  const renderNotesBlock = (title, items) => {
    if (!Array.isArray(items) || !items.length) return '';
    const body = items.map((item) => `<p>${formatMultilineText(item)}</p>`).join('');
    return `<div class="accessories-know-more-notes">${body}</div>`;
  };

  const renderLineList = (items) => {
    if (!Array.isArray(items) || !items.length) return '';
    return `<p>${items.map((item) => formatMultilineText(item, { replaceProductName: false })).join('<br>')}</p>`;
  };

  const renderSpecifications = (specifications) => {
    if (!specifications || typeof specifications !== 'object') return '';
    const entries = Object.entries(specifications);
    if (!entries.length) return '';
    return `<p>${entries
      .map(([key, value]) => {
        const safeKey = escapeHtml(key);
        const safeValue = formatMultilineText(value);
        if (String(key).trim().toLowerCase() === 'dimensions') {
          return `${safeKey}:<br>${safeValue}`;
        }
        return `${safeKey}: ${safeValue}`;
      })
      .join('<br>')}</p>`;
  };

  const getDescriptionData = (knowMoreSource) => {
    if (!knowMoreSource) return null;
    const descriptionData = knowMoreSource.description || knowMoreSource.overview;
    if (descriptionData && typeof descriptionData === 'object' && !Array.isArray(descriptionData)) {
      if (descriptionData.description || descriptionData.in_the_box || descriptionData.specifications || descriptionData.compatibility) {
        return descriptionData;
      }
    }

    if (typeof descriptionData === 'string') {
      try {
        const parsed = JSON.parse(descriptionData);
        if (parsed && typeof parsed === 'object') return parsed;
      } catch (error) {
        return null;
      }
    }

    return null;
  };

  const buildKnowMorePanelHtml = (knowMoreSource, panelKey) => {
    if (!knowMoreSource || !panelKey) return '';

    if (panelKey === 'description' || panelKey === 'overview') {
      const descriptionData = getDescriptionData(knowMoreSource);
      if (!descriptionData) return '';
      return renderParagraphs(descriptionData.description);
    }

    if (panelKey === 'notes') {
      const descriptionData = getDescriptionData(knowMoreSource);
      if (!descriptionData) return '';
      return renderNotesBlock(descriptionData.notes_title, descriptionData.notes);
    }

    if (panelKey === 'box') {
      const items = knowMoreSource.whats_in_the_box || knowMoreSource.in_the_box;
      return renderLineList(items);
    }

    if (panelKey === 'spec') {
      return renderSpecifications(knowMoreSource.specifications);
    }

    if (panelKey === 'compatibility') {
      return renderLineList(knowMoreSource.compatibility);
    }

    return '';
  };

  const getAccessoryHandleAliases = (handle) => {
    const normalized = normalizeAccessoryText(handle);
    if (!normalized) return [];
    const aliases = new Set([normalized]);

    if (normalized.includes('ev1c')) {
      aliases.add(normalized.replace(/ev1c/g, 'ev1'));
      aliases.add(normalized.replace(/ev1c/g, 'ev'));
    }

    return Array.from(aliases);
  };

  const getAccessoryTitleAliases = (title) => {
    const normalized = normalizeAccessoryText(title);
    if (!normalized) return [];
    const aliases = new Set([normalized]);

    if (normalized.includes('ev1c')) {
      aliases.add(normalized.replace(/ev1c/g, 'ev1'));
    }

    return Array.from(aliases);
  };

  const getAccessoriesKnowMoreEntry = (root) => {
    const sectionId = root?.dataset?.section;
    const productHandle = normalizeAccessoryText(root?.dataset?.productHandle);
    const productTitle = normalizeAccessoryText(root?.dataset?.productTitle);
    if (!sectionId) return null;

    const jsonScript = document.getElementById(`AccessoriesKnowMoreJSON-${sectionId}`);
    if (!jsonScript?.textContent) return null;

    let parsedData;
    try {
      parsedData = JSON.parse(jsonScript.textContent);
    } catch (error) {
      console.error('Failed to parse accessories know more JSON.', error);
      return null;
    }

    const products = Array.isArray(parsedData?.products) ? parsedData.products : [];
    const handleAliases = getAccessoryHandleAliases(productHandle);
    const titleAliases = getAccessoryTitleAliases(productTitle);
    const matched =
      products.find(
        (item) =>
          Array.isArray(item.handles) &&
          item.handles.some((handle) => handleAliases.includes(normalizeAccessoryText(handle)))
      ) ||
      products.find((item) => titleAliases.includes(normalizeAccessoryText(item.title))) ||
      null;

    if (matched) return matched;

    if (productHandle && productHandle.includes('extended-backrest')) {
      const keyword = 'extended-backrest';
      return (
        products.find(
          (item) =>
            Array.isArray(item.handles) &&
            item.handles.some((handle) => normalizeAccessoryText(handle).includes(keyword))
        ) || null
      );
    }

    return null;
  };

  const applyAccessoriesKnowMoreData = () => {
    document.querySelectorAll('product-info.product-info-new').forEach((root) => {
      const matchedEntry = getAccessoriesKnowMoreEntry(root);
      if (!matchedEntry?.know_more) return;
      const normalizedHandles = Array.isArray(matchedEntry.handles)
        ? matchedEntry.handles.map((handle) => normalizeAccessoryText(handle))
        : [];
      const notesLastHandles = new Set([
        'strutt-ev1-flight-safe-battery',
        'strutt-ev-flight-safe-battery',
        'strutt-ev1-long-range-battery',
        'strutt-ev-long-range-battery',
      ]);
      const shouldKeepNotesLast = normalizedHandles.some(
        (handle) => notesLastHandles.has(handle)
      );

      root.querySelectorAll('[data-accessories-know-more-body]').forEach((panelBody) => {
        const panelKey = panelBody.getAttribute('data-accessories-know-more-body');
        const html = buildKnowMorePanelHtml(matchedEntry.know_more, panelKey);
        
        // 动态数据为空时隐藏对应面板，避免显示占位内容
        if (!html && (panelKey === 'box' || panelKey === 'notes')) {
          panelBody.innerHTML = '';
          const panelContainer = panelBody.closest('.accessories-know-more-panel');
          if (panelContainer) {
            panelContainer.style.display = 'none';
          }
        } else if (html) {
          panelBody.innerHTML = html;
          const panelContainer = panelBody.closest('.accessories-know-more-panel');
          if (panelContainer) {
            panelContainer.style.display = '';
          }
        }
      });

      // Battery accessories keep Notes as the last panel in Know More.
      if (shouldKeepNotesLast) {
        const knowMoreCard = root.querySelector('.accessories-know-more-card');
        const notesPanel = knowMoreCard?.querySelector('[data-accessories-know-more-panel="notes"]');
        if (knowMoreCard && notesPanel) {
          knowMoreCard.appendChild(notesPanel);
        }
      }
    });
  };

  const quantityComponents = document.querySelectorAll('quantity-input');

  const getInt = (value, fallback) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  quantityComponents.forEach((component) => {
    if (component.dataset.boundQuantity === 'true') return;
    component.dataset.boundQuantity = 'true';

    const input = component.querySelector('input[type="number"]');
    if (!input) return;

    const updateButtonStates = () => {
      const value = getInt(input.value, getInt(input.getAttribute('min'), 0));
      const min = getInt(input.getAttribute('min'), getInt(input.dataset.min, 0));
      const maxAttr = input.getAttribute('max');
      const max = maxAttr != null && maxAttr !== '' ? getInt(maxAttr, Number.POSITIVE_INFINITY) : Number.POSITIVE_INFINITY;

      const minusButton = component.querySelector('button[name="minus"]');
      const plusButton = component.querySelector('button[name="plus"]');

      if (minusButton) minusButton.disabled = value <= min;
      if (plusButton) plusButton.disabled = Number.isFinite(max) && value >= max;
    };

    component.addEventListener(
      'click',
      (event) => {
        const button = event.target?.closest?.('button[name="minus"], button[name="plus"]');
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (button.disabled) return;

        const step = getInt(input.getAttribute('step'), 1);
        const min = getInt(input.getAttribute('min'), getInt(input.dataset.min, 0));
        const maxAttr = input.getAttribute('max');
        const max = maxAttr != null && maxAttr !== '' ? getInt(maxAttr, Number.POSITIVE_INFINITY) : Number.POSITIVE_INFINITY;

        const current = getInt(input.value, min);
        let next = current;

        if (button.getAttribute('name') === 'plus') next = current + step;
        if (button.getAttribute('name') === 'minus') next = current - step;

        next = Math.max(min, Math.min(max, next));

        const nextString = String(next);
        if (input.value !== nextString) {
          input.value = nextString;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        updateButtonStates();
      },
      true
    );

    input.addEventListener('change', updateButtonStates);
    updateButtonStates();
  });
  
  function resetButton() {
    const button = document.querySelector('.product-checkout-button');
    if (button) {
      button.classList.remove('component-cta-button--loading');
      button.classList.remove('component-cta-button--disabled');
      button.classList.add('component-cta-button--enabled');
      button.disabled = false;
    }
  }
  
  function showError(message) {
    const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
    const errorMessage = document.querySelector('.product-form__error-message');
    
    if (errorWrapper && errorMessage) {
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
      
      // 3秒后隐藏错误消息
      setTimeout(() => {
        errorWrapper.hidden = true;
      }, 3000);
    }
  }

  // 折叠面板功能
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  
  // 初始化：确保默认展开的项正确显示
  accordionHeaders.forEach(header => {
    const isDefaultExpanded = header.getAttribute('data-default-expanded') === 'true';
    const content = header.nextElementSibling;
    
    if (isDefaultExpanded) {
      header.setAttribute('aria-expanded', 'true');
      if (content) {
        content.classList.add('active');
      }
    }
  });
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const content = this.nextElementSibling;
      
      // 切换当前面板
      if (!isExpanded) {
        // 展开
        this.setAttribute('aria-expanded', 'true');
        if (content) {
          content.classList.add('active');
        }
      } else {
        // 收起
        this.setAttribute('aria-expanded', 'false');
        if (content) {
          content.classList.remove('active');
        }
      }
    });
  });

  document.querySelectorAll('[data-know-more]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-know-more-tab]');
    const panels = root.querySelectorAll('[data-know-more-panel]');

    if (!tabs.length || !panels.length) return;

    const setActive = (targetId) => {
      tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.getAttribute('data-know-more-target') === targetId);
      });
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === targetId);
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('data-know-more-target');
        if (!targetId) return;
        setActive(targetId);
      });
    });
  });

  applyAccessoriesKnowMoreData();
});
